<template>
	<div class="qucontent" id="cloudCenter">
		<heads></heads>
		<div class="left_box_qu">
			<div class="left_t">
				<div class="modular_title modular_title_lw">
					<img src="../../assets/tit_icon.png" />
					<div>
						问题类型
					</div>
						
				</div>
				<div id="qusType" v-show="wtlist.length>0">

				</div>
				<div class="zwsj" v-if="wtlist.length==0">
					暂无数据
				</div>
			</div>
			<div class="left_b">
				<div class="modular_title modular_title_more">
					<img src="../../assets/tit_icon.png" />
					<div>
						
						隐患按负责人分析
					</div>
				</div>
				<div id="leadingCadre" v-show="yhfxlist.length>0"></div>
				<div class="zwsj" v-if="yhfxlist.length==0">
					暂无数据
				</div>
			</div>
		</div>
		<div class="center_box_qu">
			<div class="center_b">
				<div class="modular_title modular_title_more">
					<img src="../../assets/tit_icon.png" />
					<div>
						
						质量问题曲线图
					</div>
				</div>
				<div class="tab_box">
					<ul>
						<li :class="tabIndex==0?'activeTab':''" @click="tab(0)">按周</li>
						<li :class="tabIndex==1?'activeTab':''" @click="tab(1)">按月</li>
						<li :class="tabIndex==2?'activeTab':''" @click="tab(2)">按年</li>
					</ul>
				</div>
				<div id="qualityCurve"></div>
			</div>
		</div>
		<div class="right_box">
			<div class="modular_title modular_title_more">
				<img src="../../assets/tit_icon.png" />
				<div>
					隐患
					
				</div>
			</div>
			<div id="hiddenDanger" v-show="wtzzlist.length>0">

			</div>
			<div class="zwsj1" v-if="wtzzlist.length==0">
					暂无数据
				</div>
			<div class="dang_line"></div>
			<div id="hiddenPie">

			</div>
		</div>
		<div class="center_bg"></div>
	</div>
</template>

<script>
	import heads from "@/components/header.vue"
	import { mapState } from 'vuex'
	import * as echarts from 'echarts';
	export default {
		data() {
			return {
				tabIndex: 0,
				wtlist:[],
				yhfxlist:[],
				wtzzlist:[]
			}
		},
		computed: {
			...mapState(['projectId']),
		},
		components: {
			heads,
		},
		watch:{
			projectId(newdata,olddata){
				this.hiddenDanger()
			}
		},
		created() {

		},
		mounted() {
			this.questionType()
			this.leadingCadre()
			this.qualityCurve('1')
			this.hiddenDanger()
			this.hiddenPie()
			this.resetScreenSize()
		},
		methods: {
			tab(num) {
				this.tabIndex = num				
				if(num==0){
					this.qualityCurve('1')
				}else if(num==1){
					this.qualityCurve('2')					
				}else if(num==2){
					this.qualityCurve('3')
				}
			},
			//隐患第二个图
			hiddenPie() {
				let myChart = echarts.init(document.getElementById('hiddenPie'));
				let angle = 0; //角度，用来做简单的动画效果的
				
				let   option = {
					title: [{
						text: '',
						x: 'center',
						y: 'center',
						textStyle: {
							color:'#29EEF3',
							fontSize: 36,
							
							
						}
					},
					 {
						text: '问题数量环状图',
						left: '10',
						top: '10%',
						textStyle: {
							color: "#F4E672",
							fontSize: 18
						}
					}
					],
					tooltip: {
						trigger: "item",
					},
					legend: {
						type: "plain",
	
						left: 'center',
						bottom: "5%",
						align: "auto",
						data: ['未解决','总数'],
						textStyle: {
							color: "white",
							fontSize: 16,
							padding: [10, 1, 10, 0]
						},
						
					},
					series: [{
							name: "ring5",
							type: 'custom',
							coordinateSystem: "none",
							renderItem: function(params, api) {
								return {
									type: 'arc',
									shape: {
										cx: api.getWidth() / 2,
										cy: api.getHeight() / 2,
										r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.6,
										startAngle: (0 + angle) * Math.PI / 180,
										endAngle: (90 + angle) * Math.PI / 180
									},
									style: {
										stroke: "#0CD3DB",
										fill: "transparent",
										lineWidth: 1.5
									},
									silent: true
								};
							},
							data: [0]
						}, {
							name: "ring5",
							type: 'custom',
							coordinateSystem: "none",
							renderItem: function(params, api) {
								return {
									type: 'arc',
									shape: {
										cx: api.getWidth() / 2,
										cy: api.getHeight() / 2,
										r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.6,
										startAngle: (180 + angle) * Math.PI / 180,
										endAngle: (270 + angle) * Math.PI / 180
									},
									style: {
										stroke: "#0CD3DB",
										fill: "transparent",
										lineWidth: 1.5
									},
									silent: true
								};
							},
							data: [0]
						}, {
							name: "ring5",
							type: 'custom',
							coordinateSystem: "none",
							renderItem: function(params, api) {
								return {
									type: 'arc',
									shape: {
										cx: api.getWidth() / 2,
										cy: api.getHeight() / 2,
										r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.65,
										startAngle: (270 + -angle) * Math.PI / 180,
										endAngle: (40 + -angle) * Math.PI / 180
									},
									style: {
										stroke: "#0CD3DB",
										fill: "transparent",
										lineWidth: 1.5
									},
									silent: true
								};
							},
							data: [0]
						}, {
							name: "ring5",
							type: 'custom',
							coordinateSystem: "none",
							renderItem: function(params, api) {
								return {
									type: 'arc',
									shape: {
										cx: api.getWidth() / 2,
										cy: api.getHeight() / 2,
										r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.65,
										startAngle: (90 + -angle) * Math.PI / 180,
										endAngle: (220 + -angle) * Math.PI / 180
									},
									style: {
										stroke: "#0CD3DB",
										fill: "transparent",
										lineWidth: 1.5
									},
									silent: true
								};
							},
							data: [0]
						}, {
							name: "ring5",
							type: 'custom',
							coordinateSystem: "none",
							renderItem: function(params, api) {
								let x0 = api.getWidth() / 2;
								let y0 = api.getHeight() / 2;
								let r = Math.min(api.getWidth(), api.getHeight()) / 2 * 0.65;
								let point = getCirlPoint(x0, y0, r, (90 + -angle))
								return {
									type: 'circle',
									shape: {
										cx: point.x,
										cy: point.y,
										r: 4
									},
									style: {
										stroke: "#0CD3DB", //粉
										fill: "#0CD3DB"
									},
									silent: true
								};
							},
							data: [0]
						}, {
							name: "ring5", //绿点
							type: 'custom',
							coordinateSystem: "none",
							renderItem: function(params, api) {
								let x0 = api.getWidth() / 2;
								let y0 = api.getHeight() / 2;
								let r = Math.min(api.getWidth(), api.getHeight()) / 2 * 0.65;
								let point = getCirlPoint(x0, y0, r, (270 + -angle))
								return {
									type: 'circle',
									shape: {
										cx: point.x,
										cy: point.y,
										r: 4
									},
									style: {
										stroke: "#0CD3DB", //绿
										fill: "#0CD3DB"
									},
									silent: true
								};
							},
							data: [0]
						}, {
							name: '',
							type: 'pie',
							radius: ['58%', '45%'],
							
							
							z: 0,
							zlevel: 0,
							label: {
								normal: {
									position: "center",
									
								}
							},
							data: [{
									value: '',
									name: "未解决",
									label: {
										normal: {
											show: false
										}
									},
									itemStyle: {
										normal: {
											color: { // 完成的圆环的颜色
												colorStops: [{
													offset: 0,
													color: '#5ee8fd' // 0% 处的颜色
												}, {
													offset: 1,
													color: '#5ee8fd' // 100% 处的颜色
												}]
											},
										}
									}
								},
								{
									value:'',
									name: "总数",
									label: {
										normal: {
											show: false
										}
									},
									itemStyle: {
										normal: {
											color: "#4b60a0"
										}
									}
								}
							]
						},

						{
							name: "",
							type: "gauge",
							radius: "68%",
							center: ['50%', '50%'],
							startAngle: 0,
							endAngle: 359.9,
							splitNumber: 8,
							hoverAnimation: true,
							axisTick: {
								show: false
							},
							splitLine: {
								length: 50,
								lineStyle: {
									width: 5,
									color: "#3d4a89"
								}
							},
							axisLabel: {
								show: false
							},
							pointer: {
								show: false
							},
							axisLine: {
								lineStyle: {
									opacity: 0
								}
							},
							detail: {
								show: false
							},
							data: [{
								value: 10,
								name: ""
							}]
						},

					]
				};

				//获取圆上面某点的坐标(x0,y0表示坐标，r半径，angle角度)
				function getCirlPoint(x0, y0, r, angle) {
					let x1 = x0 + r * Math.cos(angle * Math.PI / 180)
					let y1 = y0 + r * Math.sin(angle * Math.PI / 180)
					return {
						x: x1,
						y: y1
					}
				}

				function draw() {
					angle = angle + 3
					myChart.setOption(option, true)
					//window.requestAnimationFrame(draw);
				}

				setInterval(function() {
					//用setInterval做动画感觉有问题
					draw()
				}, 100);

				myChart.setOption(option)
				
				this.postAxios('/build/qualRiskDetection/selectQualQuestionsQuantity').then(res => {	// 新版
				// this.postAxios('/buildQualHiddenTrouble/selectQualQuestionsQuantity').then(res => {	// 旧版			
					console.log(res)
					let value1 = res.data.data.unfinished;
					let value2 = res.data.data.count;
					let tit=res.data.data.percent;
					option.series[6].data[0].value = value1
					option.series[6].data[1].value = value2
					option.title[0].text = tit
					myChart.setOption(option)
				}).catch(err => {})
			},
			//隐患第一个图
			hiddenDanger() {
				let myChart = echarts.init(document.getElementById('hiddenDanger'));
				let option = {
					title: {
						text: '问题数量柱状图',
						left: '10',
						top: '10%',
						textStyle: {
							color: "#F4E672",
							fontSize: 18
						}
					},
					tooltip: {
						trigger: "axis",
					},
					color: ["#96FCB0", "#3758B8"],
					grid: {
						right: "12%",
						left: "12%",
						top: "25%",
						bottom: 80
					},
					legend: {
						icon: "circle",
						top: "10%",
						right: 20,
						textStyle: {
							color: "#ffffff",
						},
					},
					xAxis: {
						data: [],
						type: 'category',
						axisLine: {
							show: true,
							color: '#A3E9FC'
						},

						axisLabel: {
							color: '#fffff',
							formatter: function(params) {
								var newParamsName = '' // 最终拼接成的字符串
								var paramsNameNumber = params.length // 实际标签的个数
								var provideNumber = 4 // 每行能显示的字的个数
								var rowNumber = Math.ceil(paramsNameNumber / provideNumber) // 换行的话，需要显示几行，向上取整
								/**
								 * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
								 */
								// 条件等同于rowNumber>1
								if(paramsNameNumber > provideNumber) {
									/** 循环每一行,p表示行 */
									for(var p = 0; p < rowNumber; p++) {
										var tempStr = '' // 表示每一次截取的字符串
										var start = p * provideNumber // 开始截取的位置
										var end = start + provideNumber // 结束截取的位置
										// 此处特殊处理最后一行的索引值
										if(p === rowNumber - 1) {
											// 最后一次不换行
											tempStr = params.substring(start, paramsNameNumber)
										} else {
											// 每一次拼接字符串并换行
											tempStr = params.substring(start, end) + '\n'
										}
										newParamsName += tempStr // 最终拼成的字符串
									}
								} else {
									// 将旧标签的值赋给新标签
									newParamsName = params
								}
								return newParamsName
							}
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#ffffff',
								opacity: 0.2
							}
						},

					},
					yAxis: {
						type: 'value',
						splitLine: {
							show: true,
							lineStyle: {
								color: '#ffffff',
								opacity: 0.2
							}
						},
						boundaryGap: true,
						axisLine: {
							show: true,
							color: 'A3E9FC'
						},
						axisLabel: {
							show: true,
							margin: 20,
							textStyle: {
								color: '#ffffff'
							}
						},
						axisTick: {
							show: false
						}
					},
					series: [{
							name: '未解决',
							type: 'bar',
							barWidth: 20,

							data: []
						},
						{
							name: '总数',
							type: 'bar',
							barWidth: 20,
							barGap: '-100%',
							z: 1,
							data: []
						},

					]
				};
				myChart.setOption(option)
				this.postAxios('/build/qualQuestions/selectHiddenDangerNumber', {"projectId":this.projectId},'json').then(res => { // 新版
				// this.postAxios('/build/qualQuestions/selectQualHiddenDanger', {"projectId":this.projectId},'json').then(res => { // 旧版
					var data = res.data.data					
					var xData = []
					var dataA = []
					var dataB = []
					this.wtzzlist=res.data.data
					data.forEach(item => {
						xData.push(item.name)
						dataA.push(item.count)
						dataB.push(item.unfinished)
					})
					
					option.xAxis.data = xData
					option.series[0].data = dataB
					option.series[1].data = dataA
							
					myChart.setOption(option, true)
				}).catch(err => {})
			},
			//质量问题曲线图
			qualityCurve(num) {
				let myChart = echarts.init(document.getElementById('qualityCurve'));
				let option = {
					tooltip: {
						trigger: "axis",
						formatter: '{b0}:{c}',
					},
					color: ["#5DC2F9", "#F5CB3B"],
					grid: {
						right: "8%",
						left: "8%",
						top: '20%',
						bottom: '20%'
					},
					legend: {
						icon: "circle",
						bottom: '6%',
						data: ['质量问题'],
						left: 20,
						textStyle: {
							color: "#ffffff",
						},
					},
					xAxis: {
						data: [],
						type: 'category',
						axisLine: {
							show: true,
							color: '#A3E9FC'
						},

						axisLabel: {
							color: '#fffff',
							width: 100,
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#ffffff',
								opacity: 0.2
							}
						},

					},
					yAxis: {
						type: 'value',
						splitLine: {
							show: true,
							lineStyle: {
								color: '#ffffff',
								opacity: 0.2
							}
						},
						boundaryGap: true,
						axisLine: {
							show: true,
							color: 'A3E9FC'
						},
						axisLabel: {
							show: true,
							margin: 20,
							textStyle: {
								color: '#ffffff'
							}
						},
						axisTick: {
							show: false
						}
					},
					series: [{
							name: "质量问题",
							type: 'bar',
							data: [],
							barWidth: '15px',
							itemStyle: {
								normal: {
									color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
										offset: 0,
										color: '#5DC2F9'
									}, {
										offset: 1,
										color: '#96FCB0'
									}], false),
								}
							},
						},
						{
							name: '质量问题',
							type: 'line',
							smooth: true,
							areaStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: 'rgba(93, 194, 249, 0)'
									},
									{
										offset: 1,
										color: 'rgba(150, 252, 176, 0.25)'
									}
								])
							},
							data: [],
							symbol: 'circle',
							symbolSize: 8,
							itemStyle: {
								normal: {
									color: '#FFFFFF',
									borderColor: 'rgba(0, 255, 240, 1)',
									lineStyle: {
										color: 'rgba(0, 255, 240, 1)'
									}
								}
							}
						},
					]
				};
				myChart.setOption(option)
				this.postAxios('/build/qualRiskDetection/selectBarData',{type:num},'json').then(res => {		// 新版
				//this.postAxios('/buildQualHiddenTrouble/selectBarData',{type:num},'json').then(res => {		// 旧版	
					let xarr=[]
					let datalist=[]
					for(let i=0;i<res.data.data.length;i++){
						xarr.push(res.data.data[i].clickDate)
						datalist.push(res.data.data[i].value)
					}
					option.xAxis.data = xarr
					
					option.series[0].data = datalist
					option.series[1].data = datalist

					myChart.setOption(option)
				}).catch(err => {})
			},
			//隐患按负责人分析
			leadingCadre() {
				let myChart = echarts.init(document.getElementById('leadingCadre'));
				let option = {
					tooltip: {
						trigger: "axis",
					},
					color: ["#5DC2F9", "#F5CB3B"],
					grid: {
						right: "12%",
						left: "12%",
						top: '20%',
						bottom: '20%'
					},
					legend: {
						icon: "circle",
						bottom: '6%',
						left: 20,
						textStyle: {
							color: "#ffffff",
						},
					},
					xAxis: {
						data: [],
						type: 'category',
						axisLine: {
							show: true,
							color: '#A3E9FC'
						},

						axisLabel: {
							color: '#fffff',
							width: 100,
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#ffffff',
								opacity: 0.2
							}
						},

					},
					yAxis: {
						type: 'value',
						splitLine: {
							show: true,
							lineStyle: {
								color: '#ffffff',
								opacity: 0.2
							}
						},
						boundaryGap: true,
						axisLine: {
							show: true,
							color: 'A3E9FC'
						},
						axisLabel: {
							show: true,
							margin: 20,
							textStyle: {
								color: '#ffffff'
							}
						},
						axisTick: {
							show: false
						}
					},
					series: [{
							name: '总数',
							type: 'bar',
							barWidth: '15',
							barGap: '100%',
							itemStyle: {
								normal: {
									barBorderRadius: 12,
								},
							},
							data: []
						},
						{
							name: '未解决',
							type: 'bar',
							barWidth: '15',
							itemStyle: {
								normal: {
									barBorderRadius: 12,
								}

							},
							data: []
						},
					]
				};
				myChart.setOption(option)
				this.postAxios('/build/qualRiskDetection/selectQualDataByPrinipal').then(res => {	// 新版
				// this.postAxios('/buildQualHiddenTrouble/selectQualDataByPrinipal').then(res => {	// 旧版			
					let datalist1=[]
					let datalist2=[]
					let xarr=[]
					this.yhfxlist=res.data.data
					for(let i=0;i<res.data.data.length;i++){
						datalist1.push(res.data.data[i].count)
						datalist2.push(res.data.data[i].unfinished)
						xarr.push(res.data.data[i].name)
						
					}
					option.xAxis.data = xarr					
					option.series[0].data = datalist1
					option.series[1].data = datalist2
					myChart.setOption(option)
				}).catch(err => {})
			},
			questionType() {

				let myChart = echarts.init(document.getElementById('qusType'));
				let option = {
					color: ["#B1CBF6", "#6FD0F9", "#E8556D", "#F2B45B", "#7BF7AB", "#FBE568", "#557FE8", "#618DBB"],
					grid: {
						left: -100,
						top: 50,
						bottom: 10,
						right: 10,
						containLabel: true
					},
					tooltip: {
						trigger: 'item',
						formatter: "{b} : {c} ({d}%)"
					},
					legend: {					
						left: 'center',											
						textStyle: {
							color: '#A3E2F4',
							fontSize: 12,
							fontWeight: 0
						},
						　formatter: function(name){
						　　　　return name.length>2?name.substr(0,2)+"...":name;
						　　},
					
						
					},
					polar: {
						radius: "60%"
					},
					angleAxis: {
						interval: 1,
						type: 'category',
						data: [],
						z: 10,

						axisLine: {
							show: false,
							lineStyle: {
								color: "#0B4A6B",
								width: 1,
								type: "solid"
							},
						},
						axisLabel: {
							interval: 0,
							show: true,
							color: "#0B4A6B",
							margin: 8,
							fontSize: 16
						},
					},
					radiusAxis: {
						min: 40,
						max: 120,
						interval: 20,
						axisLine: {
							show: false,
							lineStyle: {
								color: "#0B3E5E",
								width: 1,
								type: "solid"
							},
						},
						axisLabel: {
							formatter: '{value} %',
							show: false,
							padding: [0, 0, 20, 0],
							color: "#0B3E5E",
							fontSize: 16
						},
						splitLine: {
							lineStyle: {
								color: "#2F5CA6",
								width: 2,
								type: "solid"
							}
						}
					},
					calculable: true,
					series: [{
						type: 'pie',
						radius: ["5%", "10%"],
						hoverAnimation: false,
						labelLine: {
							normal: {
								show: false,
								length: 30,
								length2: 55
							},
							emphasis: {
								show: false
							}
						},
						data: [{
							name: '',
							value: 0,
							itemStyle: {
								normal: {
									color: "#2F5CA6"
								}
							}
						}]
					}, {
						type: 'pie',
						radius: ["60%", "65%"],
						hoverAnimation: false,
						labelLine: {
							normal: {
								show: false,
								length: 30,
								length2: 55
							},
							emphasis: {
								show: false
							}
						},
						name: "",
						data: [{
							name: '',
							value: 0,
							itemStyle: {
								normal: {
									color: "#2F5CA6"
								}
							}
						}]
					}, {
						stack: 'a',
						type: 'pie',
						radius: ['20%', '60%'],
						roseType: 'area',
						zlevel: 10,
						label: {

							normal: {
								show: true,
								
								textStyle: {
									fontSize: 12,
									color: '#ffffff',
								},

								position: 'outside'
							},
							emphasis: {
								show: true
							}
						},
						labelLine: {
							normal: {
								show: true,
								length: 20,
								length2: 20
							},
							emphasis: {
								show: false
							}
						},
						data: [
						]
					}, ]
				}
				myChart.setOption(option)
				this.postAxios('/build/qualRiskDetection/selectPieData').then(res => {	// 新版
				// this.postAxios('/build/buildQualHiddenTrouble/selectPieData').then(res => {	// 旧版 		
					let datalist=res.data.data
					this.wtlist=res.data.data
					let xarr=[]
					for(let i=0;i<res.data.data.length;i++){
						xarr.push(res.data.data[i].name)
					}
					option.legend.data = xarr
					
					option.series[2].data = datalist
					myChart.setOption(option)
					
				}).catch(err => {})
			},
			resetScreenSize(dw, dh) {
				if(window.innerWidth > 1000) {
					function init() {
						var _el = document.getElementById('cloudCenter');
						var hScale = window.innerHeight / (dh || 1080);
						var wScale = window.innerWidth / (dw || 1920);
						_el.style.transform = 'scaleX(' + wScale + ') scaleY(' + hScale + ')'
					}
					var lazyFun;
					window.onresize = function() {
						clearTimeout(lazyFun);
						lazyFun = setTimeout(function() {
							init()
						}, 600)
					}
					init()
				}
			}
		}
	}
</script>

<style scoped>
	@import "./index.css";
	.qucontent{
		position: relative;
	}
	.center_bg{
		position: absolute;
		width: 818px;
		height: 597px;
		left: 50%;
		z-index: -1;
		transform: translateX(-50%);
	}
	.left_box_qu {
		float: left;
		margin-left: 31px;
	}
	
	.left_t {
		height: 440px;
		width: 475px;
		margin-top: 20px;
	}
	
	.modular_title {
		display: flex;		
		padding: 0 10px 0 20px;		
		align-items: center;		
		font-size: 22px;
		color: #FFFFFF;		
		line-height: 52px;
	}	
	.modular_title div{
		height: 52px;
		display: inline-block;
		background: url(../../assets/tit_bg.png) no-repeat center bottom;
		background-size:100% 17px;
	}
	
	.modular_title img {
		margin-right: 9px;
		vertical-align: middle;
	}
	
	#qusType,
	#leadingCadre {
		width: 475px;
		height: 388px;
	}
	
	.left_b {
		height: 440px;
		width: 475px;
		margin-top: 20px;
	}
	
	.center_box_qu {
		float: left;
		margin-left: 19px;
	}
	
	.center_b {
		width: 877px;
		height: 440px;
		margin-top: 484px;
	}
	
	.tab_box {
		height: 32px;
	}
	
	.tab_box ul {
		width: 420px;
		float: right;
		display: flex;
		justify-content: space-between;
		margin-right: 60px;
	}
	
	.tab_box ul li {
		width: 94px;
		text-align: center;
		height: 30px;
		line-height: 30px;
		border: 1px solid #82C7F6;
		border-radius: 4px;
		color: #FFFFFF;
		font-size: 14px;
		list-style-type: none;
	}
	
	.tab_box .activeTab {
		background: rgba(99, 172, 213, 0.9);
	}
	
	#qualityCurve {
		width: 877px;
		height: 356px;
	}
	
	.right_box {
		float: left;
		margin-left: 20px;
		height: 904px;
		width: 475px;
		margin-top: 20px;
	}
	
	#hiddenDanger {
		width: 475px;
		height: 388px;
	}
	.zwsj1{
		font-size: 12px;
		text-align: center;
		color: #CCCCCC;
		height: 398px;
		margin-top: 20px;
	}
	.dang_line {
		width: 443px;
		height: 4px;
		margin: 0 auto;
		margin-top: 20px;
	}
	
	#hiddenPie {
		width: 475px;
		height: 435px;
	}
	.zwsj{
		font-size: 12px;
		text-align: center;
		margin-top: 20px;
		color: #CCCCCC;
	}
</style>